import React from 'react';
import { CenterFrameLayout } from 'Layouts';
import ProfileSignIn from '../ProfileSignIn';

const SecondScreen = (props) => {
  return (
    <CenterFrameLayout customClass="signInLayout" title={'Sign In to Your Account'} noPanel>
      <div className="signIn">
        <div className="panel profile">
          <div className="panelWrapper">
            <ProfileSignIn {...props} isDeviceActivation />
          </div>
        </div>
      </div>
    </CenterFrameLayout>
  );
};

export default SecondScreen;
